<div id="mmc-overview-model">

    <div class="block">
        <label class="labelMmcOverview">
            Model Name: <span class="red">*</span>
            <span class="infoIcon"
                  calltoaction [calltoactionTemplate]="modelNameTemplateRef" calltoactionPosition="bottom"></span>
            <ng-template #modelNameTemplateRef>
                The name you enter is the model name advisors will see in the Model Market Center.
            </ng-template>
        </label>
        <span tooltip [tooltipTitle]="modelNameTooltipMessage" tooltipClass="error" tooltipPosition="right" [tooltipHorizontalOffset]="10">
            <irb-validation-text-box [(value)]="modelMarketName" (change)="validateModelName()"
                                     width="400px" max="100" [disabled]="data.isProcessing"></irb-validation-text-box>
        </span>

        <span style="padding-left: 20px; " *ngIf="data.modelMarketId">
            <b>Model ID:</b> {{data.modelMarketId}}
        </span>
    </div>

        <div class="block">
            <label class="labelMmcOverview">
                AS Firm ID: <span class="red">*</span>
            </label>
            <irb-validation-text-box #asFirmIdBox [(value)]="advisorFirmId" regExp="^[0-9]+$"
                                     (valueChange)="onAsFirmIdInput()"
                                     invalidMessage="Please enter 1 to 15 digit." width="130px"
                                     min="1" max="15" [disabled]="data.isProcessing"></irb-validation-text-box>
        </div>

    <div class="block">
        <label class="labelMmcOverview">
            Asset class:
            <span class="infoIcon"
                  calltoaction [calltoactionTemplate]="assetClassTemplateRef" calltoactionPosition="bottom"></span>
            <ng-template #assetClassTemplateRef>
                Select an asset class from the list. If you don't see an asset class that correctly represents this
                model, contact your Relationship Manager to have one added.
            </ng-template>
        </label>
        <irb-dropdown-filter #IrbDropdownAssetClass (search)="getAssetClasses($event)" size="30" [value]="assetClass"
                             [disabled]="isProcessing"
                             (selection)="onAssetClassChange($event)"></irb-dropdown-filter>
    </div>

<div class="block">
  <label class="labelMmcOverview">
    Building block style:
    <span class="infoIcon"
    calltoaction [calltoactionTemplate]="bbsTemplateRef" calltoactionPosition="bottom"></span>
    <ng-template #bbsTemplateRef>
      <div class="block">The building block style refers to the ETFs or funds that make up this model - e.g.
        active, passive, smart beta, or a mix.
      </div>
      <div class="block">The holdings in active funds may turn over frequently in an attempt to outperform a
        benchmark, while the holdings in passive funds are selected to mimic an index. Smart beta funds use
        a combination of both passive and active strategies while using preset and transparent rules.
      </div>
      <p><strong>Please note:</strong> Individual equities are considered passive.</p>
    </ng-template>
  </label>
  <p-radioButton name="BUILDING_BLOCK_STYLE" value="active" [disabled]="isProcessing"
    [(ngModel)]="buildingBlockStyle"
    (ngModelChange)="validateEntries()"
  inputId="mmccustovmodelitem1"></p-radioButton>
  <label for="mmccustovmodelitem1" [class.p-disabled]="isProcessing">Active</label>
  <p-radioButton name="BUILDING_BLOCK_STYLE" value="passive" [disabled]="isProcessing"
    [(ngModel)]="buildingBlockStyle"
    (ngModelChange)="validateEntries()"
  inputId="mmccustovmodelitem2"></p-radioButton>
  <label for="mmccustovmodelitem2" [class.p-disabled]="isProcessing">Passive</label>
  <p-radioButton name="BUILDING_BLOCK_STYLE" value="Smart Beta"
    [disabled]="isProcessing"
    [(ngModel)]="buildingBlockStyle"
    (ngModelChange)="validateEntries()"
  inputId="mmccustovmodelitem3"></p-radioButton>
  <label for="mmccustovmodelitem3" [class.p-disabled]="isProcessing">Smart Beta</label>
  <p-radioButton name="BUILDING_BLOCK_STYLE" value="mixed" [disabled]="isProcessing"
    [(ngModel)]="buildingBlockStyle"
    (ngModelChange)="validateEntries()"
  inputId="mmccustovmodelitem4"></p-radioButton>
  <label for="mmccustovmodelitem4" [class.p-disabled]="isProcessing">Mixed</label>
  <p-radioButton name="BUILDING_BLOCK_STYLE" value="none" [disabled]="isProcessing"
    [(ngModel)]="buildingBlockStyle"
    (ngModelChange)="validateEntries()"
  inputId="mmccustovmodelitem5"></p-radioButton>
  <label for="mmccustovmodelitem5" [class.p-disabled]="isProcessing">None</label>
</div>

<div class="block">
  <label class="labelMmcOverview">
    Used for: <span class="red">*</span>
    <span class="infoIcon"
    calltoaction [calltoactionTemplate]="usedForTemplateRef" calltoactionPosition="bottom"></span>
    <ng-template #usedForTemplateRef>
      Indicate whether your firm believes this model is best suited for a client's complete strategy, or
      whether this model is best when blended with another model (sleeve).
    </ng-template>
  </label>
  <p-radioButton name="USED_FOR" value="cstrategy" [disabled]="true"
    [(ngModel)]="usedFor"
    (ngModelChange)="validateEntries()"
  inputId="mmccustovmodelitem6"></p-radioButton>
  <label for="mmccustovmodelitem6" [class.p-disabled]="true">Complete Strategy</label>
  <p-radioButton name="USED_FOR" value="sleeve" [disabled]="true"
    [(ngModel)]="usedFor"
    (ngModelChange)="validateEntries()"
  inputId="mmccustovmodelitem7"></p-radioButton>
  <label for="mmccustovmodelitem7" [class.p-disabled]="true">Sleeve</label>
  <p-radioButton name="USED_FOR" value="income" [disabled]="true"
    [(ngModel)]="usedFor"
    (ngModelChange)="validateEntries()"
  inputId="mmccustovmodelitem8"></p-radioButton>
  <label for="mmccustovmodelitem8" [class.p-disabled]="true">Income</label>
  <p-radioButton name="USED_FOR" value="custom" [disabled]="true"
    [(ngModel)]="usedFor"
    (ngModelChange)="validateEntries()"
  inputId="mmccustovmodelitem9"></p-radioButton>
  <label for="mmccustovmodelitem9" [class.p-disabled]="true">Custom</label>
</div>

    <div class="block">
        <label class="labelMmcOverview">
            Turnover:
            <span class="infoIcon"
                  calltoaction [calltoactionTemplate]="turnoverTemplateRef" calltoactionPosition="bottom"></span>
            <ng-template #turnoverTemplateRef>
                This is the annual turnover for this model for the previous calendar year. Turnover is calculated by
                taking the total net buys and sells and dividing that by the portfolio (or representative account)
                value.
            </ng-template>
        </label>

        <irb-number-text-box #txtTurnover [(value)]="turnover" places="2"
                             [disabled]="isProcessing" (valueChange)="onTurnoverInput()"
                             width="80px"
        ></irb-number-text-box>
        &nbsp; %
    </div>

    <div class="block">
        <label class="labelMmcOverview">
            Allocation changes:
            <span class="infoIcon"
                  calltoaction [calltoactionTemplate]="assetAllocTemplateRef" calltoactionPosition="bottom"></span>
            <ng-template #assetAllocTemplateRef>
                Select when the allocation is changed.
            </ng-template>
        </label>
        <irb-dropdown-filter #IrbDropdownAllocChanges (search)="getAllocChanges($event)" size="30"
                             [disabled]="isProcessing"
                             [value]="allocationChangesSel"
                             (selection)="onAllocChngChange($event)"></irb-dropdown-filter>
    </div>

    <div class="block">
        <label class="labelMmcOverview">
            Risk category:
            <span class="infoIcon"
                  calltoaction [calltoactionTemplate]="riskCategoryTemplateRef" calltoactionPosition="bottom"></span>
            <ng-template #riskCategoryTemplateRef>
                Select a risk category from the list. Typically, the risk category of the model is defined by the
                model's volatility range.
            </ng-template>
        </label>
        <irb-dropdown-filter #IrbDropdownRiskTolerance (search)="getRiskTolerances($event)" size="30"
                             [value]="riskTolerance"
                             [disabled]="isProcessing"
                             (selection)="onRiskCategoryChange($event)"></irb-dropdown-filter>
    </div>

<div class="block">
  <label class="labelMmcOverview">
    Socially responsible:
    <span class="infoIcon"
    calltoaction [calltoactionTemplate]="socRespTemplateRef" calltoactionPosition="bottom"></span>
    <ng-template #socRespTemplateRef>
      <div class="block">Socially responsible models are models containing ETFs or mutual funds that hold
        securities in companies that follow certain social, religious, or environmental beliefs.
      </div>
      <div>Schwab does not do any due diligence on this designation; it is solely up to you, the
        investment manager, to ensure that the models are correctly represented.
      </div>
    </ng-template>
  </label>
  <p-radioButton name="SOCIALLY_RESPONSIBLE" [value]="true" [disabled]="isProcessing"
    [(ngModel)]="isSociallyResponsible"
    (ngModelChange)="validateEntries()"
  inputId="mmccustovmodelitem10"></p-radioButton>
  <label for="mmccustovmodelitem10" [class.p-disabled]="isProcessing">Yes</label>
  <p-radioButton name="SOCIALLY_RESPONSIBLE" [value]="false" [disabled]="isProcessing"
    [(ngModel)]="isSociallyResponsible"
    (ngModelChange)="validateEntries()"
  inputId="mmccustovmodelitem11"></p-radioButton>
  <label for="mmccustovmodelitem11" [class.p-disabled]="isProcessing">No</label>
  <p-radioButton name="SOCIALLY_RESPONSIBLE" [value]="-1" [disabled]="isProcessing"
    [(ngModel)]="isSociallyResponsible"
    (ngModelChange)="validateEntries()"
  inputId="mmccustovmodelitem12"></p-radioButton>
  <label for="mmccustovmodelitem12" [class.p-disabled]="isProcessing">None</label>
</div>

</div>
